import { gql } from '@apollo/client';

export const DELETE_PARENT = gql`
  mutation DeleteParent($input: DeleteParentInput!) {
    deleteParent(input: $input) {
      parentId
    }
  }
`;
